// Dev-only chat harness — /dev-chat mounts the REAL tutor runtime +
// panel outside AuthWrapper so Playwright can drive the chat without
// Google OAuth (the backend's development mode authenticates absent
// credentials as the 'anonymous' user). STRICTLY development: any
// other NODE_ENV renders null, and CRA inlines NODE_ENV at build time
// so production bundles compile this to nothing reachable.
import React, { useEffect } from 'react';

import { TutorRuntimeProvider, useTutor } from '../contexts/TutorRuntimeContext';
import TutorPanel from './TutorPanel';

function DevChatInner() {
  const { openPanel } = useTutor();
  useEffect(() => { openPanel(); }, [openPanel]);
  return (
    <div className="min-h-screen bg-surface-muted p-6" data-testid="dev-chat">
      <p className="font-mono text-xs text-mutedink">
        dev-chat harness — panel docked right; backend must run in
        development mode on the configured API URL.
      </p>
      <TutorPanel />
    </div>
  );
}

export default function DevChat() {
  if (process.env.NODE_ENV !== 'development') return null;
  return (
    <TutorRuntimeProvider>
      <DevChatInner />
    </TutorRuntimeProvider>
  );
}
